import React, { Component } from 'react';

import VirtualizedList from '../VirtualizedList';
import { clocksPerPage } from 'config';
import App from '../../../models/app';
import { ClockRow } from './ClockRow';
import { ClockListContainer } from './Common';

const CLOCKS_PER_ROW = 3;

interface VirtualizedClockListProps {
  apps: App[];
  hasNextPage: boolean;
  fetchMore: (args: any) => void;
  navbarHeight: number;
  listHeader?: React.ReactNode;
  collectionId?: string;
}

export class VirtualizedClockList extends Component<VirtualizedClockListProps> {
  isItemLoaded = ({ index }: { index: number }) => {
    const { apps } = this.props;
    const adjustedIndex = index * CLOCKS_PER_ROW;
    return !!(
      (adjustedIndex === 0 || apps[adjustedIndex - 1]) &&
      apps[adjustedIndex]
    );
  };

  fetchMore = ({ startIndex }: { startIndex: number }): any => {
    if (this.props.fetchMore) {
      return this.props.fetchMore({ startIndex: startIndex * CLOCKS_PER_ROW });
    }
  };

  render() {
    const { apps, hasNextPage, navbarHeight, listHeader, collectionId } = this.props;

    const pageSize = clocksPerPage / CLOCKS_PER_ROW;
    const clocksCount = Math.ceil(apps.length / CLOCKS_PER_ROW);
    return (
      <ClockListContainer hasHeader={!!listHeader}>
        <VirtualizedList
          isApp={false}
          currentCount={clocksCount}
          maxCount={!hasNextPage ? clocksCount : undefined}
          pageSize={pageSize}
          isItemLoaded={this.isItemLoaded}
          fetchMore={this.fetchMore}
          navbarHeight={navbarHeight}
          listHeader={listHeader}
        >
          {({ index }: any) => (
            <ClockRow index={index} apps={apps} collectionId={collectionId}/>
          )}
        </VirtualizedList>
      </ClockListContainer>
    );
  }
}
